<template>
  <div class="goods_list_container">   
	 <!-- 筛选区域 -->
    <div class="goods_list clearfix">
		<div class="all_result_tip flex_row_start_center"><span ><router-link  to="/">
			首页</router-link></span><div class="all" >> 全部结果</div></div>
		<div class="select_info">
			<div class="sel_info_content">
				<div class="sel_info_item seled flex_row_start_start" v-if="seledInfos.data.length>0">
				  <div class="sii_title">已选：</div>
				  <div class="sii_items">
					<div class="sii_item flex_row_start_center" @click="onSelItemTap(selItem,selIndex)"  @mouseenter="selItemFoucse(1,selItem,selIndex)" @mouseleave="selItemFoucse(0,selItem,selIndex)" v-for="(selItem,selIndex) in seledInfos.data" :key="selIndex">
						<div class="sel_txt" v-if='selItem.type==selType.data.price'>价格：{{priceList.data[selItem.subIndex].name}}</div>
						<div class="sel_txt" v-else>{{attributeList.data[selItem.mainIndex].attributeName}}：{{attributeList.data[selItem.mainIndex].attributeValueList[selItem.subIndex].attributeValue}}</div>
						<div class="sel_del_container">							
							<img class="sel_del"  v-if="selItem.isFocus" src="@/assets/goods/icon_del_white.png"/>
							<img class="sel_del" v-else  src="@/assets/goods/icon_del_black.png"/>
						</div>
						
					</div>
				  </div>  
				</div>
				<div class="sel_info_item  flex_row_start_start">					
					<div class="sii_title">高级选项：</div>
					<div class="sii_items">
						<div class="sii_item flex_row_start_center" :ref="`attr${attrIndex}`"  @mouseenter="attrItemFoucse(1,attrIndex,atrrItem)" @mouseleave="attrItemFoucse(0,attrIndex,atrrItem)"  v-for="(atrrItem,attrIndex) in attributeList.data" :key="attrIndex">
							<div class="attributeName" :class="{hasFoucus:atrrItem.isFocus}">{{atrrItem.attributeName}}</div>
							
							<img class="dir_tip_icon" v-if='atrrItem.isFocus'  src="@/assets/goods/up_arraw_40.png"/>
							<img class="dir_tip_icon" v-else  src="@/assets/goods/down_arraw_40.png"/>
							
							<div class="attrValue_items" :style="{left:atrrItem.attrValueLeft+'px'}"  >
								<div class="attrv_items_inner">
									<div class="attrValue_item" :class="{sel:priceItem.seled}"  @click="onPriceValeTap(selType.data.price,priceItem,attrIndex,priceIndex)" v-if='atrrItem.isPrice'  v-for="(priceItem,priceIndex) in priceList.data" :key="priceIndex">{{priceItem.name}}</div>
									<div class="attrValue_item" :class="{sel:atrrValueItem.seled}"  @click="onAttrValeTap(selType.data.attr,atrrValueItem,attrIndex,atrrValueIndex)" v-else  v-for="(atrrValueItem,atrrValueIndex) in atrrItem.attributeValueList" :key="atrrValueIndex">{{atrrValueItem.attributeValue}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="sort_info flex_row_start_center">			
			<div class="sort_txt" :class="{sel:sortInfo.data.zonghe}" @click="onZhSortTap">综合推荐</div>
			<div class="sort_sep"></div>
			<div class="sort_item price flex_row_start_center" @click="onPriceSortTap" :class="{sel:sortInfo.data.price}">
				<div class="sort_txt " :class="{sel:sortInfo.data.price}">价格</div>
				<img class="sort_icon " v-if='sortInfo.data.price&&sortInfo.data.priceUp==0' src="@/assets/goods/icon_price_up_sel.png"/>
				<img class="sort_icon " v-else-if='sortInfo.data.price&&sortInfo.data.priceUp==1'  src="@/assets/goods/icon_price_down_sel.png"/>
				<img class="sort_icon " v-else  src="@/assets/goods/icon_price_up.png"/>
			</div>
			<div class="sort_stub" style="flex:1"></div>
			<div class="sort_item flex_row_start_center" @click="onNewPSortTap">
				<img class="sort_icon" v-if="sortInfo.data.newProduct" src="@/assets/goods/icon_checked.png"/>
				<img class="sort_icon" v-else src="@/assets/goods/icon_uncheck.png"/>
				<div class="sort_txt" :class="{sel:sortInfo.data.newProduct}">新品</div>
			</div>
			<div class="sort_item flex_row_start_center" @click="onFreeSortTap">
				<img class="sort_icon" v-if="sortInfo.data.free" src="@/assets/goods/icon_checked.png"/>
				<img class="sort_icon" v-else src="@/assets/goods/icon_uncheck.png"/>
				<div class="sort_txt" :class="{sel:sortInfo.data.free}">免息</div>
			</div>
			<div class="sort_item flex_row_start_center" @click="onOnlyStoreSortTap">
				<img class="sort_icon" v-if="sortInfo.data.onlyStore" src="@/assets/goods/icon_checked.png"/>
				<img class="sort_icon" v-else src="@/assets/goods/icon_uncheck.png"/>
				<div class="sort_txt" :class="{sel:sortInfo.data.onlyStore}">仅看有货</div>
			</div>			
		</div>      
    </div>
	
    <!-- 商品列表 -->
	<div class="goods_container">
		<div class="goods_item" @click="toGoodsDetail(goodsIndex,goodsItem.productId)" v-for="(goodsItem,goodsIndex) in goodsData.data" :key="goodsIndex">
			<img class="goods-img" :src="goodsItem.mainImageUrl"/>
			<div class="goods-name">				
				<img  class="new_product_img" v-if="goodsItem.newProdcut" src="@/assets/goods/icon_newproduct.png"/>
				<div class="new_product_name">{{goodsItem.productShortTitle}}</div>
			</div>
			<div class="goods-short" v-if="goodsItem.specValues">{{goodsItem.specValues}}</div>
			<div class="promotion flex_row_start_center" v-if='goodsItem.hasAct||goodsItem.actShowList&&goodsItem.actShowList.length>0'>
				<div class="act_item act"  v-if='goodsItem.firstOrder'>
					{{ goodsItem.showFirstName}}
				</div>
				
				<div class="act_item" v-else-if='goodsItem.isFlashSale'>
					{{ goodsItem.showName}}
				</div>
				<div  class="act_item act"  v-else-if='goodsItem.hasAct'>
					{{ goodsItem.showName}}
				</div>			
				
				<div  class="act_item"  v-for="(item,index) in goodsItem.actShowList" :key='index'>
					{{item}}
				</div>
			</div>
			<div class="goods-price flex_row_center_center">
				<template v-if='goodsItem.hasAct'>
					<div class="productPrice" :class="{wait:goodsItem.promotionType==107&&!goodsItem.activityPrice}" >
						{{goodsItem.promotionType==107&&!goodsItem.activityPrice?'待发布':'¥'+goodsItem.activityPrice.toFixed(2)}}
					</div>
					<div class="origlnalPrice" v-if='!(goodsItem.promotionType==107&&!goodsItem.activityPrice)'>
						¥{{goodsItem.productPrice.toFixed(2)}}
					</div>	
				</template>
				
				<div class="productPrice " v-else>
					¥{{goodsItem.productPrice.toFixed(2)}}
				
				</div>
			</div>
			<div class="fav_duibi">
				<div class="fd_container fav" @click.stop="collectGoods(goodsItem.productId, goodsItem.isFollowGoods)">
					<img class="fd_icon" v-if='goodsItem.isFollowGoods' src="@/assets/goods/icon_favatared.png"/>
					<img class="fd_icon" v-else src="@/assets/goods/icon_favatar.png"/>
					<div class="fd_txt">收藏</div>
				</div>
				<!-- <div class="fd_container" @click.stop="onDuibiTap()">
					<img class="fd_icon" src="@/assets/goods/icon_duibi.png"/>
					<div class="fd_txt">添加对比</div>
				</div> -->
			</div>		
		</div>
	</div>	
	<SldCommonEmpty v-show="isEmpty" />

    <!-- 分页 -->
    <div class="flex_row_center_center sld_pagination">
      <el-pagination @current-change="handleCurrentChange" v-model:currentPage="goodsData.page.current" :page-size="goodsData.page.pageSize"
        layout="prev, pager, next, jumper" :total="goodsData.page.total" :hide-on-single-page="true">
      </el-pagination>
    </div>

    <SldLoginModal :visibleFlag="loginModalVisibleFlag" @closeLoingModal="closeLoingModal" />
    
	<!-- 侧边按钮 -->
	<!-- <div class="fixed_btn">
		<div class="fb_container sev flex_column_center_center" @click.top="onSevTap()">
			<img class="fb_icon" src="@/assets/goods/icon_service.png"/>
			<div class="fb_txt">咨询客服</div>			
		</div> -->
		
		
		<!-- <div class="fb_container flex_column_center_center" @click.stop="onDuibiTap()">
			<img class="fb_icon" src="@/assets/goods/icon_duibi.png"/>
			<div class="fb_txt">对比</div>
		</div> -->
		<!-- <div class="fb_container flex_column_center_center" @click.stop="toTopTap()">
			<img class="fb_icon" src="@/assets/goods/icon_top.png"/>
			<div class="fb_txt">返回顶部</div>
			</div>
	</div> -->

	<KefuSlip class="side_menu" @goTop="goTop" :showGotoTop="showSideMenu" :style="sideStyle"></KefuSlip>
  
  </div>
</template>
<script>
import {
  getCurrentInstance,
  onMounted,
  onBeforeUnmount,
  reactive,
  ref,
  watch
} from 'vue'
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import KefuSlip from '../../components/KefuSlip'
import SldLoginModal from '../../components/loginModal'
import SldCommonEmpty from '../../components/SldCommonEmpty'

export default {
  name: 'goodsList',
  components: {
    SldLoginModal,
    SldCommonEmpty,
		KefuSlip
  },
  setup () {
    const firstLoading = ref(true) //是否第一次加载
    const skeletonData = reactive({ data: [] })
    const store = useStore()
    const loginModalVisibleFlag = ref(false) //登录弹框是否显示，默认不显示
    const initSkeletonData = () => {
      for (let i = 0; i < 10; i++) {
        skeletonData.data.push({
          goodsName: '',
          goodsImage: '',
          productPrice: '',
          saleNum: '',
          activityList: '',
          isFollowGoods: '',
          defaultProductId: ''
        })
      }
    }
    initSkeletonData()
    const route = useRoute()
    const router = useRouter()
   

    const params = reactive({
      //初始化的请求参数
      current: 1,
	  pageSize:25,
    })
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const goodsData = reactive({ data: [], page: {} })  //商品列表
    const attributeList=reactive({data:[]})
		const showSideMenu = ref(false)
	  const seledInfos=reactive({data:[
		// {
		// 	type:0,// 0-属性  1- price  2--分类  3-
		// 	mainIndex:0,
		// 	subIndex:0, 
			
		// }
	]});//已选择的属性
	const sideStyle = ref('');
	const selType=reactive({data:{
		attr:0,
		price:1,
		category:2
		
	}})
	
	const priceList=reactive({data:[
		{
			name:'0-2999元',
			low:0,
			high:2999,
			seled:0,
		},
		{
			name:'3000-4999元',
			low:3000,
			high:4999,
			seled:0,
		},
		{
			name:'5000-7999元',
			low:5000,
			high:7999,
			seled:0,
		},
		{
			name:'8000-10999元',
			low:8000,
			high:10999,
			seled:0,
		},
		{
			name:'11000-15999元',
			low:11000,
			high:15999,
			seled:0,
		},
		{
			name:'16000-20999元',
			low:16000,
			high:20999,
			seled:0,
		},		
	]})
	
	const sortInfo=reactive({
		data:{
			zonghe:1,//综合  0-未选择 ；1- 选择
			price:0,//价格  0-未选择  1-选择			
			priceUp:0,//价格 0-升序    1-降序
			newProduct:0,//新品
			free:0,//免息  
			onlyStore:0,// 紧看有货			
		}
	})
	
	
    
    
    const isEmpty = ref(false)
    const keyword = ref(
      route.query.keyword != undefined && route.query.keyword
        ? route.query.keyword
        : ''
    ) //搜索关键词
    const isFromSearch =ref(
      route.query.source != undefined && route.query.source=='search'
        ? true
        : false
    )  //
    const searchType= ref( route.query.type != undefined && route.query.type
        ? route.query.type
        : '')  //搜索类型
    

    const scrollTop = ref(null)


	


    //方法------------------------------
    //初始化数据，进行请求-start
    const getInitData = (params, fromPagination,formLoad) => {
      window.scrollTo(0, scrollTop.value)

			if(window.innerHeight > 570){
        let top = (window.innerHeight - 450) / 2
        sideStyle.value = 'top:' + top + 'px'
      } else{
        sideStyle.value = 'top:120px'
      }

	  if(!fromPagination){
		  params.current=1
	  }
      let searchParams = { ...params }
      proxy.$post('v3/goods/front/goods/productList', searchParams, 'json').then(res => {
        
        firstLoading.value = false
		
		 //just for test
         //res=getProductListTest()
		
        if (res.state == 200) {
          goodsData.data = res.data.list.map(item => {
            if(item.activityList){
					var tmpList=[]
					var actList=[]
					var zplist=[];
					var mxList=[];
					var yhqlist=[]
					
					item.activityList.forEach((aItem)=>{
						if(aItem.promotionType==403){ //赠品
							zplist.push('赠品');
						
						}else if(aItem.promotionType==405){
							mxList=mxList.concat(aItem.descriptionList)
							
						}else if(aItem.promotionType==402){
							yhqlist=yhqlist.concat(aItem.descriptionList)
						
						}
						
						else if(aItem.promotionType==103){
							// aItem.promotionName='预售'
							// aItem.hasAct=1;
							item.hasAct=1;
							item.promotionType=aItem.promotionType;
							item.showName='预售';
							// actList.push(aItem)
							
						
						}
						else if(aItem.promotionType==106){
							// aItem.promotionName='抢购'
							// aItem.hasAct=1;
							item.hasAct=1;
							item.isFlashSale=true
							item.promotionType=aItem.promotionType;
							item.showName='限时';
							//actList.push(aItem)
							
						
						}
						else if(aItem.promotionType==107){
							// aItem.promotionName='预约'
							// aItem.hasAct=1;
							item.hasAct=1;
							item.promotionType=aItem.promotionType;	
							item.showName='预约';									
							//actList.push(aItem)
							
						
						}
						else if(aItem.promotionType==501){
							item.hasAct=1;
							item.firstOrder=1; 
							item.promotionType=aItem.promotionType;	
							item.showFirstName='专享';	
						}
						else if(aItem.promotionType==408){	//新品  									
							item.newProdcut=1; 
							item.promotionType=aItem.promotionType;	
							
						}
					})								
												
					tmpList=zplist.concat(mxList)
					tmpList=tmpList.concat(yhqlist)								
					item.actShowList=tmpList.length>3?tmpList.slice(0,3):tmpList;								
				}else {
					item.actShowList=[]
				}
		
            return item
          })


          isEmpty.value = res.data.list.length ? false : true
          goodsData.page= res.data.pagination
          
          if(formLoad&&isFromSearch.value){
            getSearchResultStatics(res.data.pagination.total)
          }
        }else{
          ElMessage(res.msg)
		  goodsData.page={}
		  goodsData.data=[]
		  
        }
      })
    }

    const getscreenList=()=>{
      proxy.$post('v3/goods/front/goods/category/screenListNew', {}, 'json').then(res => {

        //just for test
        //res=getscreenListTest()
	
		
		
		
        if (res.state == 200) {
			if (res.data.categoryList != null) {
				
			}
			if (res.data.brandList != null) {
				
			}
			res.data.attributeList=res.data.attributeList||[]
			if (res.data.attributeList != null) {							
				let priceAttr={
					attributeName:'价格',
					isPrice:1,
				}
				res.data.attributeList.unshift(priceAttr)
				res.data.attributeList.map(item => {
					item.attrValueLeft=0;
					item.isFocus=0;// 是否聚焦
				})
				attributeList.data = res.data.attributeList;	
			}
			
		} else {
			//ElMessage(res.msg);
			/*添加price属性*/
			let priceAttr={
				attributeName:'价格',
				isPrice:1,
			}
			attributeList.data.unshift(priceAttr)
			attributeList.data.map(item => {
				item.attrValueLeft=0;
				item.isFocus=0;// 是否聚焦
			})
			
		}
		
      })
    }


    //初始化数据，进行请求-end
    const toGoodsDetail=(index,productId)=>{
			let newWin = router.resolve({
				path: `/goods/detail`,
				query: {productId:productId}
			})
			window.open(newWin.href, '_blank')

      // window.open(`/goods/detail?productId=${productId}`, '_blank');
      // router.push({
      //     path: `/goods/detail`,
      //     query: { productId: productId}
      //   });
       if(isFromSearch.value){
          searchResClickStatics(index,productId)
       }
    }
    /*搜索返回结果*/
	const getSearchResultStatics=(resNum)=>{
		let params={
			results_num:resNum,
			search_type:searchType.value,	
			page_path:'',
			search_keywords:keyword.value,
		}
		proxy.$drgStatEvent('amall_search_results_returned',params)
	}
	/*点击搜索结果*/
	const searchResClickStatics=(index,productId)=>{	
		let params={
			results_click_num:index,
			product_sn:productId,						
			search_keywords:keyword.value,
		}
		proxy.$drgStatEvent('amall_search_results_click',params)
	}

    
    //页数改变的方法-start
    const handlePrevCilickChange = e => {
      params.current = e
      getInitData(params,true)
    }
    const handleNextCilickChange = e => {
      params.current = e
      getInitData(params, true)
    }
    const handleCurrentChange = e => {
      params.current = e
      getInitData(params, true)
    }
    //页数改变的方法-end
	
	const onDuibiTap=()=>{
		ElMessage('功能还没实现')
	}
	
	const onSevTap=()=>{
	  //ElMessage('功能还没实现')		
      let newWin = router.resolve({
		  path: '/service',
      })
      window.open(newWin.href, '_blank')
	}
	
	const toTopTap=()=>{
		  window.scrollTo(0, 0)
	}
    //收藏及取消收藏商品
    const collectGoods = (productId, isFollowGoods) => {
      if (store.state.loginFlag) {
        //已登录
        let params = {
          productIds: productId,
          isCollect: !isFollowGoods
        }
        proxy.$post('v3/member/front/followProduct/edit', params).then(res => {
          if (res.state == 200) {
            ElMessage.success(res.msg)
            goodsData.data.map(goodsItem => {
              if (goodsItem.productId == productId) {
					goodsItem.isFollowGoods = !isFollowGoods
              }
            })
          } else {
            ElMessage.error(res.msg)
          }
        })
      } else {
        //未登录提示登录
        // loginModalVisibleFlag.value = true
        goToByPush("/login", {});
      }
    }
    //关闭登录弹框
    const closeLoingModal = () => {
      loginModalVisibleFlag.value = false
    }
    
    watch(
      () => route.query.keyword,
      (nv, ov) => {
        if (nv && nv != ov) {
          keyword.value = nv
          params.keyword = route.query.keyword  
          getInitData(params)
        }
      }
    )



	const selItemFoucse=(type,selItem,selIndex)=>{
		selItem.isFocus=type;
	}
	
	
	// 判断鼠标是否移入属性页面区间
	const attrItemFoucse=(type,attrIndex,atrrItem)=>{
		if(type==1){  //进入
			if(atrrItem.attrValueLeft==0){
				let offsetLeft=proxy.$refs[`attr${attrIndex}`].offsetLeft;
				atrrItem.attrValueLeft=-offsetLeft;
			}
		}

		atrrItem.isFocus=type;
		
	}
	
	const onSelItemTap=(selItem,selIndex)=>{
		if(selItem.type==selType.data.attr){//属性
			let attrValue=attributeList.data[selItem.mainIndex].attributeValueList[selItem.subIndex];
			attrValue.seled=0
			let delIndex=params['categoryIds'].findIndex(id=>{
				  return id==attrValue.valueId				
				}
			)

			if(delIndex!=-1){
				params['categoryIds'].splice(delIndex, 1);
			}
			getInitData(params)
			
		}else if(selItem.type==selType.data.price){
			priceList.data[selItem.subIndex].seled=0;
			delete params.highPrice
			delete params.lowPrice
			getInitData(params)
		}
		seledInfos.data.splice(selIndex, 1);
		
		
	}
	
	const onAttrValeTap=(type,atrrValueItem,mainIndex,subIndex)=>{			
		let selInfo={
			type:type,
			mainIndex:mainIndex,
			subIndex:subIndex,
		}
		
		atrrValueItem['seled']=atrrValueItem['seled']?0:1;//
		if(atrrValueItem['seled']){
			seledInfos.data.push(selInfo)
		}else{
			/*删除*/
			delSelInfoItem(type,mainIndex,subIndex)
			
		}
		
		/*进行搜索*/
		let ids=[]
		seledInfos.data.forEach((item)=>{
			
			if(item.type==selType.data.attr){
				ids.push(attributeList.data[item.mainIndex].attributeValueList[item.subIndex].valueId)
			}
		})
		
		params['categoryIds']=ids
		getInitData(params)
		
	}
	
	const onPriceValeTap=(type,priceItem,mainIndex,subIndex)=>{

		let selInfo={
			type:type,
			mainIndex:mainIndex,
			subIndex:subIndex,
			
		}
		let oldselIndex=-1;
		for(let i=0;i<priceList.data.length;i++){
			if(priceList.data[i].seled){
				oldselIndex=i;
				break
			}
		}
		
		if(oldselIndex==subIndex){
			priceItem.seled=0;
			/*删除*/
			delSelInfoItem(type,mainIndex,subIndex)
						
		}else{
			if(oldselIndex!=-1){
				priceList.data[oldselIndex].seled=0;
				/*删除*/
				delSelInfoItem(type,mainIndex,oldselIndex)
			}
			
			priceItem.seled=1;
			seledInfos.data.push(selInfo)
		}
		/*进行搜索*/
		let lowP='';
		let highP=''
		for(let i=0;i<priceList.data.length;i++){
			if(priceList.data[i].seled){
				lowP=priceList.data[i].low;
				highP=priceList.data[i].high;
				break
			}
		}
		if(lowP&&highP){
			params['lowPrice']=lowP
			params['highPrice']=highP
		}else{
			delete params.highPrice
			delete params.lowPrice
		}
		getInitData(params)
	}
	
	const delSelInfoItem=(type,mainIndex,subIndex)=>{
		let delItem=null;
		let index = seledInfos.data.findIndex(item =>
			item.type==type&&item.mainIndex==mainIndex&&item.subIndex==subIndex				
		)
		if (index != -1) {			
		    delItem=seledInfos.data.splice(index, 1);
		}
	}
	
	/*综合推荐*/
	const onZhSortTap=()=>{
		if(sortInfo.data.zonghe==0){
			 scrollTop.value = document.body.scrollTop || document.documentElement.scrollTop
			sortInfo.data.zonghe=1;
			sortInfo.data.price=0;
			sortInfo.data.priceUp=0;
			doSort()
		}else{
			//sortInfo.data.zonghe=0;
		}
		
		
	}
	
	const onPriceSortTap=()=>{
		scrollTop.value = document.body.scrollTop || document.documentElement.scrollTop
		if(sortInfo.data.price==0){
			sortInfo.data.zonghe=0;
			sortInfo.data.price=1;
			sortInfo.data.priceUp=0;
		}else{
			sortInfo.data.priceUp=sortInfo.data.priceUp==0?1:0;
		}
		doSort()
		
	}
	const onNewPSortTap=()=>{
		scrollTop.value = document.body.scrollTop || document.documentElement.scrollTop
		sortInfo.data.newProduct=sortInfo.data.newProduct==0?1:0
		doSort()
	}
	const onFreeSortTap=()=>{
		scrollTop.value = document.body.scrollTop || document.documentElement.scrollTop
		sortInfo.data.free=sortInfo.data.free==0?1:0
		doSort()
	}
	const onOnlyStoreSortTap=()=>{
		scrollTop.value = document.body.scrollTop || document.documentElement.scrollTop
		sortInfo.data.onlyStore=sortInfo.data.onlyStore==0?1:0
		doSort()
	}
	
	const doSort=()=>{
		let sort=0;		
		if(sortInfo.data.price){
			sort=sortInfo.data.priceUp?4:3
			
		}
		params['sort']=sort
		if(sortInfo.data.newProduct||sortInfo.data.free){
			params['promotionTypes']=[]
			if(sortInfo.data.newProduct){
				params['promotionTypes'].push(408)  //新品
			}
			if(sortInfo.data.free){
				params['promotionTypes'].push(405)//免息
			}
			
		}else{
			delete params.promotionTypes
		}
		if(sortInfo.data.free){ //还未处理
		
		}
		if(sortInfo.data.onlyStore){
			params['store']=1
		}else{
			params['store']=0
		}
		getInitData(params)
		
	}
	
	// 排序 0:默认排序；1销量；2评论；3价格从低到高；4、价格从高到低；5、人气从高到低；6、收藏数从高到低；7、店铺推荐
	const dealSortInfo=(sort)=>{
		if(sort==0){
			sortInfo.data.zonghe=1;
			sortInfo.data.price=0;
			sortInfo.data.priceUp=0;			
		}else if(sort==3){
			sortInfo.data.zonghe=0;
			sortInfo.data.price=1;
			sortInfo.data.priceUp=0;
		}
	}
	

    

    onMounted(() => {

      let query = ['categoryId', 'keyword',  'tagId',  'sort', 'lowPrice']

      query.forEach(key => {
        if (route.query[key]) {
          if (key == 'categoryId' ) {
             params['categoryIds'] = (route.query[key]+'').split(",")
          }
		  else if(key == 'tagId'){
			  params['labelIds'] = (route.query[key]+'').split(",")
		  }  
		  else {
            params[key] = route.query[key]
          }
          if (route.query.sort) {
             /*进行处理*/
			dealSortInfo(route.query.sort)
			 
          }
        }
      })
      getInitData(params,false,true)
      getscreenList();

			window.addEventListener('scroll', scrollHandle) 
	  
	  	document.addEventListener('visibilitychange', handleVisibilityChange);
    })

	onBeforeUnmount(()=>{	
		document.removeEventListener('visibilitychange', handleVisibilityChange);
		window.removeEventListener('scroll', scrollHandle) 
	})

	const goTop = () =>{
		window.scrollTo({
			top: 0, // 滚动到页面顶部
			behavior: 'smooth' // 平滑滚动（可选）
		});
	}

	const handleVisibilityChange=()=>{
      if (document.visibilityState === 'visible') {
        console.log('窗口变为了可见状态');
		getInitData(params)
       
      } else if (document.visibilityState === 'hidden') {
        console.log('窗口变为了隐藏状态');
        
      }
    }

	
		const scrollHandle = (event) =>{
			if (window.scrollY >= 250) {
        showSideMenu.value = true;
      } else if (window.scrollY < 250) {
        showSideMenu.value = false;
      }
		}


    const goToByPush =(type,param = {})  => {
			router.push({
        path: type,
        query: param
      });
	}

	const getProductListTest=()=>{
		return {
			"data": {
				"pagination": {
					"current": 1,
					"total": 110,
					"pageSize": 20
				},
				"list": [
					{
						"productShortTitle": "星空经典蓝色",
						"marketPrice": null,
						"isBooking": null,
						"goodsId": 100002030004,
						"goodsSubtitle": "无线4K有线8K回报",
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "咨询客服享好礼！官方补贴见右角标！",
						"activityList": [
							// {
							// 	"promotionGrade": null,
							// 	"promotionName": "首单专享活动",
							// 	"promotionType": 501,
							// 	"descriptionList": null,
							// 	"startTime": null,
							// 	"goodsPromotionId": null,
							// 	"memberCategories": null,
							// 	"promotionId": null,
							// 	"platforms": null
							// },
							{
								"promotionGrade": null,
								"promotionName": "新品",
								"promotionType": 408,
								"descriptionList": null,
								"startTime": null,
								"goodsPromotionId": null,
								"memberCategories": null,
								"promotionId": null,
								"platforms": null
							},
							{
								"promotionGrade": 103,
								"promotionName": "预售活动",
								"promotionType": 107,
								"descriptionList": null,
								"startTime": "2024-10-31 10:00:59",
								"goodsPromotionId": 700,
								"memberCategories": "[36,17,1,0]",
								"promotionId": 53,
								"platforms": null
							},
							{
								"promotionGrade": null,
								"promotionName": null,
								"promotionType": 403,
								"descriptionList": null,
								"startTime": null,
								"goodsPromotionId": null,
								"memberCategories": null,
								"promotionId": null,
								"platforms": null
							},
							{
							"promotionGrade": 1,
							"promotionName": "免息",
							"promotionType": 405,
							"descriptionList": ["花呗6期免息"],
							"startTime": "2024-10-31 10:00:59",
							"goodsPromotionId": 700,
							"memberCategories": "[36,17,1,0]",
							"promotionId": 53,
							"platforms": null
						}],
						"goodsName": "ROG月刃2 ACE 三模游戏鼠标 AimPoint Pro光学传感器 月耀白",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/2eXwPq6lpSKTJGz3VpX.jpg?bindId=283?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002090005,
						"specValues": "默认",
						"writeImageUrl": null,
						"defaultProductId": 200002090005,
						"storeId": 460003,
						"saleNum": 111,
						"categoryId1": 286450,
						"categoryId2": 286461,
						"commentsNumber": 0,
						"categoryId3": 286509,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 199.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 8499.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": 300,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [{
							"promotionGrade": 1,
							"promotionName": "加价购活动",
							"promotionType": 406,
							"descriptionList": null,
							"startTime": "2024-11-02 00:00:00",
							"goodsPromotionId": 735,
							"memberCategories": "[1,17,36,0]",
							"promotionId": 57,
							"platforms": null
						}],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590003,
						"specValues": "i9-13900H 16G 1TB 2.5K 冰川银",
						"writeImageUrl": null,
						"defaultProductId": 200001590003,
						"storeId": 460003,
						"saleNum": 3,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 7499.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 6799.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590002,
						"specValues": "i9-13900H 32G 1TB 2.5K ",
						"writeImageUrl": null,
						"defaultProductId": 200001590002,
						"storeId": 460003,
						"saleNum": 2,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 6199.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 7499.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": 100,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [{
							"promotionGrade": 1,
							"promotionName": "加价购活动",
							"promotionType": 406,
							"descriptionList": null,
							"startTime": "2024-11-20 00:00:00",
							"goodsPromotionId": 857,
							"memberCategories": "[1,17,36,0]",
							"promotionId": 69,
							"platforms": null
						}, 
						{
							"promotionGrade": null,
							"promotionName": null,
							"promotionType": 402,
							"descriptionList": ["满5000元打7.3折"],
							"startTime": null,
							"goodsPromotionId": null,
							"memberCategories": null,
							"promotionId": null,
							"platforms": null
						}],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590004,
						"specValues": "Ultra7 32G 1TB 2.8K 冰川银",
						"writeImageUrl": null,
						"defaultProductId": 200001590004,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 6999.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 7499.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590005,
						"specValues": "Ultra7 32G 1TB 2.8K 夜空蓝 ",
						"writeImageUrl": null,
						"defaultProductId": 200001590005,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 6999.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 6799.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590006,
						"specValues": "Ultra9 32G 1TB 2.8K 冰川银",
						"writeImageUrl": null,
						"defaultProductId": 200001590006,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 5899.0
					},
					{
						"productShortTitle": "wmw短标题20241129001-07",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190008,
						"specValues": "魔幻青 |512GB |【吹雪S D5】ROG Z890-A WIFI ",
						"writeImageUrl": null,
						"defaultProductId": 200002190008,
						"storeId": 460003,
						"saleNum": 5,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 9999999.0
					},
					{
						"productShortTitle": "wmw短标题20241129001-08",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190009,
						"specValues": "魔幻青 |512GB |【热销】夜魔 月曜白 NX雪武白轴 ",
						"writeImageUrl": null,
						"defaultProductId": 200002190009,
						"storeId": 460003,
						"saleNum": 2,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 16523.51
					},
					{
						"productShortTitle": "165Hz 高色域",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002020005,
						"goodsSubtitle": "锐龙版 16英寸电竞",
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "AI PC为游戏和创作赋能！100W PD快充，快速补能！加购全面保享晒单再返30！",
						"activityList": [],
						"goodsName": "华硕枪神 Pro 锐龙版 16英寸电竞游戏本 笔记本电脑 ",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/tqbhfuyquI7X2e63zSX.png?bindId=247?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002080006,
						"specValues": "R9-7940HX,魔幻青",
						"writeImageUrl": null,
						"defaultProductId": 200002080006,
						"storeId": 460003,
						"saleNum": 11,
						"categoryId1": 286450,
						"categoryId2": 286462,
						"commentsNumber": 0,
						"categoryId3": 286507,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 8279.0
					},
					{
						"productShortTitle": "wmw短标题20241129001-06",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190007,
						"specValues": "日蚀灰 |1TB |【TUF电竞特工白】TUF-RTX4070TIS-O16G-WHIT",
						"writeImageUrl": null,
						"defaultProductId": 200002190007,
						"storeId": 460003,
						"saleNum": 1,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 1568.95
					},
					{
						"productShortTitle": "wmw短标题20241129001-09",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190010,
						"specValues": "魔幻青 |512GB |【TUF电竞特工白】TUF-RTX4070TIS-O16G-WHIT",
						"writeImageUrl": null,
						"defaultProductId": 200002190010,
						"storeId": 460003,
						"saleNum": 1,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 4989466.46
					},
					{
						"productShortTitle": "wmw短标题20241129001-12",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190013,
						"specValues": "魔幻青 |1TB |【TUF电竞特工白】TUF-RTX4070TIS-O16G-WHIT",
						"writeImageUrl": null,
						"defaultProductId": 200002190013,
						"storeId": 460003,
						"saleNum": 1,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 45613.47
					},
					{
						"productShortTitle": "wmw短标题20241129001-01一共可以填写30字呢",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190002,
						"specValues": "日蚀灰 |512GB |【吹雪S D5】ROG Z890-A WIFI ",
						"writeImageUrl": null,
						"defaultProductId": 200002190002,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 5321.1
					},
					{
						"productShortTitle": "改下改下wmw短标题20241129001-02",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190003,
						"specValues": "日蚀灰 |512GB |【热销】夜魔 月曜白 NX雪武白轴 ",
						"writeImageUrl": null,
						"defaultProductId": 200002190003,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 48650.15
					},
					{
						"productShortTitle": "wmw短标题20241129001-03",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190004,
						"specValues": "日蚀灰 |512GB |【TUF电竞特工白】TUF-RTX4070TIS-O16G-WHIT",
						"writeImageUrl": null,
						"defaultProductId": 200002190004,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 132.17
					},
					{
						"productShortTitle": "wmw短标题20241129001-04",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190005,
						"specValues": "日蚀灰 |1TB |【吹雪S D5】ROG Z890-A WIFI ",
						"writeImageUrl": null,
						"defaultProductId": 200002190005,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 155318.51
					},
					{
						"productShortTitle": "wmw短标题20241129001-05",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190006,
						"specValues": "日蚀灰 |1TB |【热销】夜魔 月曜白 NX雪武白轴 ",
						"writeImageUrl": null,
						"defaultProductId": 200002190006,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 5623.16
					},
					{
						"productShortTitle": "wmw短标题20241129001-10",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190011,
						"specValues": "魔幻青 |1TB |【吹雪S D5】ROG Z890-A WIFI ",
						"writeImageUrl": null,
						"defaultProductId": 200002190011,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 652156.85
					},
					{
						"productShortTitle": "wmw短标题20241129001-11",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190012,
						"specValues": "魔幻青 |1TB |【热销】夜魔 月曜白 NX雪武白轴 ",
						"writeImageUrl": null,
						"defaultProductId": 200002190012,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 13506.84
					},
					{
						"productShortTitle": "165Hz 高色域",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002020005,
						"goodsSubtitle": "锐龙版 16英寸电竞",
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "AI PC为游戏和创作赋能！100W PD快充，快速补能！加购全面保享晒单再返30！",
						"activityList": [],
						"goodsName": "华硕枪神 Pro 锐龙版 16英寸电竞游戏本 笔记本电脑 ",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/tqbhfuyquI7X2e63zSX.png?bindId=247?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002080007,
						"specValues": "R9-7940HX,日蚀灰",
						"writeImageUrl": null,
						"defaultProductId": 200002080007,
						"storeId": 460003,
						"saleNum": 5,
						"categoryId1": 286450,
						"categoryId2": 286462,
						"commentsNumber": 0,
						"categoryId3": 286507,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 8479.0
					}
				]
			},
			"msg": "成功",
			"state": 200,
			"timestamp": 1740104237962
		}
	}

  const getscreenListTest=()=>{
	  
	  
	  
      return {
        "data": {
            "attributeList": [
                {
                    "attributeId": 2,
                    "attributeValueList": [
                        {
                            "valueId": 610,
                            "attributeValue": "红色"
                        },
                        {
                            "valueId": 609,
                            "attributeValue": "桃红色"
                        },
                        {
                            "valueId": 608,
                            "attributeValue": "粉红色"
                        },
                        {
                            "valueId": 607,
                            "attributeValue": "粉色"
                        },
                        {
                            "valueId": 606,
                            "attributeValue": "紫红色"
                        },
                        {
                            "valueId": 605,
                            "attributeValue": "橘红色"
                        },
                        {
                            "valueId": 604,
                            "attributeValue": "橙色"
                        },
                        {
                            "valueId": 603,
                            "attributeValue": "黄色"
                        },
                        {
                            "valueId": 602,
                            "attributeValue": "夺目黄"
                        },
                        {
                            "valueId": 601,
                            "attributeValue": "浅黄色"
                        },
                        {
                            "valueId": 600,
                            "attributeValue": "深黄色"
                        },
                        {
                            "valueId": 599,
                            "attributeValue": "绿色"
                        },
                        {
                            "valueId": 598,
                            "attributeValue": "深绿色"
                        },
                        {
                            "valueId": 597,
                            "attributeValue": "浅绿色"
                        },
                        {
                            "valueId": 596,
                            "attributeValue": "墨绿色"
                        },
                        {
                            "valueId": 594,
                            "attributeValue": "青色"
                        },
                        {
                            "valueId": 593,
                            "attributeValue": "蓝色"
                        },
                        {
                            "valueId": 592,
                            "attributeValue": "电光蓝"
                        },
                        {
                            "valueId": 591,
                            "attributeValue": "霹雳蓝"
                        },
                        {
                            "valueId": 590,
                            "attributeValue": "深蓝色"
                        },
                        {
                            "valueId": 589,
                            "attributeValue": "浅蓝色"
                        },
                        {
                            "valueId": 588,
                            "attributeValue": "深海蓝"
                        },
                        {
                            "valueId": 587,
                            "attributeValue": "紫色"
                        },
                        {
                            "valueId": 586,
                            "attributeValue": "浅紫色"
                        },
                        {
                            "valueId": 585,
                            "attributeValue": "深紫色"
                        },
                        {
                            "valueId": 584,
                            "attributeValue": "香芋紫"
                        },
                        {
                            "valueId": 583,
                            "attributeValue": "棕色"
                        },
                        {
                            "valueId": 582,
                            "attributeValue": "深棕色"
                        },
                        {
                            "valueId": 581,
                            "attributeValue": "浅棕色"
                        },
                        {
                            "valueId": 580,
                            "attributeValue": "烟棕色"
                        },
                        {
                            "valueId": 579,
                            "attributeValue": "灰色"
                        },
                        {
                            "valueId": 578,
                            "attributeValue": "深灰色"
                        },
                        {
                            "valueId": 577,
                            "attributeValue": "浅灰色"
                        },
                        {
                            "valueId": 576,
                            "attributeValue": "银色"
                        },
                        {
                            "valueId": 575,
                            "attributeValue": "银黑色"
                        },
                        {
                            "valueId": 574,
                            "attributeValue": "银灰色"
                        },
                        {
                            "valueId": 573,
                            "attributeValue": "黑色"
                        },
                        {
                            "valueId": 572,
                            "attributeValue": "光泽黑褐色"
                        },
                        {
                            "valueId": 571,
                            "attributeValue": "亚光黑色"
                        },
                        {
                            "valueId": 570,
                            "attributeValue": "黑褐色"
                        },
                        {
                            "valueId": 569,
                            "attributeValue": "黑曜岩"
                        },
                        {
                            "valueId": 568,
                            "attributeValue": "金色"
                        },
                        {
                            "valueId": 567,
                            "attributeValue": "玫瑰金"
                        },
                        {
                            "valueId": 566,
                            "attributeValue": "香槟金"
                        },
                        {
                            "valueId": 565,
                            "attributeValue": "冰柱金"
                        },
                        {
                            "valueId": 564,
                            "attributeValue": "白色"
                        },
                        {
                            "valueId": 563,
                            "attributeValue": "玫红色"
                        },
                        {
                            "valueId": 562,
                            "attributeValue": "乳白色"
                        },
                        {
                            "valueId": 561,
                            "attributeValue": "皇家蓝"
                        },
                        {
                            "valueId": 560,
                            "attributeValue": "石英灰"
                        },
                        {
                            "valueId": 559,
                            "attributeValue": "钛金"
                        },
                        {
                            "valueId": 558,
                            "attributeValue": "棕黑色"
                        },
                        {
                            "valueId": 557,
                            "attributeValue": "无"
                        },
                        {
                            "valueId": 556,
                            "attributeValue": "尊爵蓝"
                        },
                        {
                            "valueId": 555,
                            "attributeValue": "星空灰"
                        },
                        {
                            "valueId": 554,
                            "attributeValue": "金属黑"
                        },
                        {
                            "valueId": 553,
                            "attributeValue": "勃艮第红"
                        },
                        {
                            "valueId": 552,
                            "attributeValue": "深宝石蓝"
                        },
                        {
                            "valueId": 551,
                            "attributeValue": "皓月银"
                        },
                        {
                            "valueId": 550,
                            "attributeValue": "水晶灰"
                        },
                        {
                            "valueId": 549,
                            "attributeValue": "test"
                        },
                        {
                            "valueId": 548,
                            "attributeValue": "蓝葡萄"
                        },
                        {
                            "valueId": 547,
                            "attributeValue": "红葡萄"
                        }
                    ],
                    "attributeName": "商品颜色N"
                },
                {
                    "attributeId": 18,
                    "attributeValueList": [
                        {
                            "valueId": 185,
                            "attributeValue": "512MB/4GB"
                        }
                    ],
                    "attributeName": "选择规格"
                },
                {
                    "attributeId": 17,
                    "attributeValueList": [
                        {
                            "valueId": 182,
                            "attributeValue": "银色表盘驼色真皮表带"
                        },
                        {
                            "valueId": 181,
                            "attributeValue": "黑色表盘蓝色真皮表带"
                        },
                        {
                            "valueId": 180,
                            "attributeValue": "黑色表盘黑色不锈钢竹节表带"
                        }
                    ],
                    "attributeName": "商品颜色"
                },
                {
                    "attributeId": 16,
                    "attributeValueList": [
                        {
                            "valueId": 280,
                            "attributeValue": "无"
                        },
                        {
                            "valueId": 267,
                            "attributeValue": "4GB/128GB"
                        },
                        {
                            "valueId": 255,
                            "attributeValue": "6GB/256GB"
                        },
                        {
                            "valueId": 242,
                            "attributeValue": "1GB/8GB"
                        },
                        {
                            "valueId": 179,
                            "attributeValue": "4GB/64GB"
                        },
                        {
                            "valueId": 178,
                            "attributeValue": "4GB/32GB"
                        },
                        {
                            "valueId": 177,
                            "attributeValue": "4GB/16GB"
                        },
                        {
                            "valueId": 176,
                            "attributeValue": "3GB/64GB"
                        },
                        {
                            "valueId": 175,
                            "attributeValue": "3GB/32GB"
                        },
                        {
                            "valueId": 174,
                            "attributeValue": "3GB/16GB"
                        },
                        {
                            "valueId": 173,
                            "attributeValue": "3GB/8GB"
                        },
                        {
                            "valueId": 172,
                            "attributeValue": "2GB/32GB"
                        },
                        {
                            "valueId": 171,
                            "attributeValue": "2GB/16GB"
                        },
                        {
                            "valueId": 170,
                            "attributeValue": "2GB/8GB"
                        }
                    ],
                    "attributeName": "存储规格"
                },
                {
                    "attributeId": 10,
                    "attributeValueList": [
                        {
                            "valueId": 495,
                            "attributeValue": "i7-5200U/4G/1TB"
                        },
                        {
                            "valueId": 134,
                            "attributeValue": "i7-6500/8G/1TB+128G"
                        },
                        {
                            "valueId": 133,
                            "attributeValue": "i5-6200U/4G/500G5400"
                        }
                    ],
                    "attributeName": "选择规格"
                },
                {
                    "attributeId": 9,
                    "attributeValueList": [
                        {
                            "valueId": 183,
                            "attributeValue": "i7-6820/16G/1TB+512G"
                        },
                        {
                            "valueId": 132,
                            "attributeValue": "i7-6820/16G/2TB+512G"
                        },
                        {
                            "valueId": 131,
                            "attributeValue": "i7-6820/16G/1TB+256G"
                        },
                        {
                            "valueId": 130,
                            "attributeValue": "i7-6700/8G/1TB+128G"
                        },
                        {
                            "valueId": 129,
                            "attributeValue": "i7-6700/16G/1TB+256G"
                        }
                    ],
                    "attributeName": "选择配置"
                },
                {
                    "attributeId": 8,
                    "attributeValueList": [
                        {
                            "valueId": 127,
                            "attributeValue": "DVD Super Multi"
                        },
                        {
                            "valueId": 126,
                            "attributeValue": "无光驱"
                        }
                    ],
                    "attributeName": "选择光驱"
                },
                {
                    "attributeId": 7,
                    "attributeValueList": [
                        {
                            "valueId": 125,
                            "attributeValue": "HD（1366X768）"
                        },
                        {
                            "valueId": 123,
                            "attributeValue": "UHD (3840X2160)"
                        }
                    ],
                    "attributeName": "选择分辨率"
                },
                {
                    "attributeId": 6,
                    "attributeValueList": [
                        {
                            "valueId": 261,
                            "attributeValue": "AMD R5 M420 2GB"
                        },
                        {
                            "valueId": 234,
                            "attributeValue": "GTX950 4GB"
                        },
                        {
                            "valueId": 233,
                            "attributeValue": "GTX950 2GB"
                        },
                        {
                            "valueId": 190,
                            "attributeValue": "AMD R9 270 2G"
                        },
                        {
                            "valueId": 128,
                            "attributeValue": "AMD R7 M260DX"
                        },
                        {
                            "valueId": 122,
                            "attributeValue": "AMD R5 235X 1GB"
                        },
                        {
                            "valueId": 121,
                            "attributeValue": "AMD R5 310 2GB"
                        },
                        {
                            "valueId": 120,
                            "attributeValue": "GTX1080 8GB"
                        },
                        {
                            "valueId": 119,
                            "attributeValue": "GTX1070 8GB"
                        },
                        {
                            "valueId": 118,
                            "attributeValue": "GTX980 8GB"
                        },
                        {
                            "valueId": 117,
                            "attributeValue": "GTX TITAN X 12GB"
                        },
                        {
                            "valueId": 116,
                            "attributeValue": "双GTX980 4GB"
                        },
                        {
                            "valueId": 115,
                            "attributeValue": "GTX980 4GB"
                        },
                        {
                            "valueId": 114,
                            "attributeValue": "GTX970 6GB"
                        },
                        {
                            "valueId": 113,
                            "attributeValue": "GTX970 4GB"
                        },
                        {
                            "valueId": 112,
                            "attributeValue": "GTX970 3GB"
                        },
                        {
                            "valueId": 111,
                            "attributeValue": "GTX960 2GB"
                        },
                        {
                            "valueId": 110,
                            "attributeValue": "GTX760 3GB"
                        },
                        {
                            "valueId": 109,
                            "attributeValue": "GTX760 2GB"
                        },
                        {
                            "valueId": 108,
                            "attributeValue": "GT730 2GB"
                        },
                        {
                            "valueId": 107,
                            "attributeValue": "GT720 2GB"
                        },
                        {
                            "valueId": 106,
                            "attributeValue": "独立显卡"
                        },
                        {
                            "valueId": 105,
                            "attributeValue": "集成显卡"
                        }
                    ],
                    "attributeName": "选择显卡"
                },
                {
                    "attributeId": 5,
                    "attributeValueList": [
                        {
                            "valueId": 230,
                            "attributeValue": "1TB5400可自行扩充2TB"
                        },
                        {
                            "valueId": 229,
                            "attributeValue": "500GB7200+128GB"
                        },
                        {
                            "valueId": 212,
                            "attributeValue": "500GB5400+128GB"
                        },
                        {
                            "valueId": 104,
                            "attributeValue": "3TB7200+512GB"
                        },
                        {
                            "valueId": 103,
                            "attributeValue": "3TB5400+512GB"
                        },
                        {
                            "valueId": 102,
                            "attributeValue": "3TB7200+256GB"
                        },
                        {
                            "valueId": 101,
                            "attributeValue": "3TB5400+256GB"
                        },
                        {
                            "valueId": 100,
                            "attributeValue": "3TB7200+128GB"
                        },
                        {
                            "valueId": 99,
                            "attributeValue": "3TB5400+128GB"
                        },
                        {
                            "valueId": 98,
                            "attributeValue": "3TB 7200RPM"
                        },
                        {
                            "valueId": 97,
                            "attributeValue": "3TB 5400RPM"
                        },
                        {
                            "valueId": 96,
                            "attributeValue": "2TB7200+512G"
                        },
                        {
                            "valueId": 95,
                            "attributeValue": "2TB5400+512G"
                        },
                        {
                            "valueId": 94,
                            "attributeValue": "2TB7200+128GB"
                        },
                        {
                            "valueId": 93,
                            "attributeValue": "2TB5400+128GB"
                        },
                        {
                            "valueId": 92,
                            "attributeValue": "2TB 7200RPM"
                        },
                        {
                            "valueId": 91,
                            "attributeValue": "2TB 5400RPM"
                        },
                        {
                            "valueId": 90,
                            "attributeValue": "1TB7200+128GB"
                        },
                        {
                            "valueId": 89,
                            "attributeValue": "1TB5400+128GB"
                        },
                        {
                            "valueId": 88,
                            "attributeValue": "1TB7200+24GB"
                        },
                        {
                            "valueId": 87,
                            "attributeValue": "1TB5400+24GB"
                        },
                        {
                            "valueId": 86,
                            "attributeValue": "1TB 7200RPM"
                        },
                        {
                            "valueId": 85,
                            "attributeValue": "1TB 5400RPM"
                        },
                        {
                            "valueId": 84,
                            "attributeValue": "500GB 7200RPM"
                        },
                        {
                            "valueId": 83,
                            "attributeValue": "500GB+24GB SSD"
                        },
                        {
                            "valueId": 82,
                            "attributeValue": "500GB 5400RPM"
                        },
                        {
                            "valueId": 81,
                            "attributeValue": "512GB SSD"
                        },
                        {
                            "valueId": 80,
                            "attributeValue": "256GB SSD"
                        },
                        {
                            "valueId": 79,
                            "attributeValue": "128GB SSD"
                        },
                        {
                            "valueId": 78,
                            "attributeValue": "128GB EMMC"
                        },
                        {
                            "valueId": 77,
                            "attributeValue": "32GB EMMC"
                        }
                    ],
                    "attributeName": "选择硬盘"
                },
                {
                    "attributeId": 3,
                    "attributeValueList": [
                        {
                            "valueId": 268,
                            "attributeValue": "酷睿 i5-7300HQ"
                        },
                        {
                            "valueId": 135,
                            "attributeValue": "奔腾&reg; G4400"
                        },
                        {
                            "valueId": 67,
                            "attributeValue": "AMD A10-8700P"
                        },
                        {
                            "valueId": 66,
                            "attributeValue": "AMD FX-8800P"
                        },
                        {
                            "valueId": 65,
                            "attributeValue": "x5-Z8300"
                        },
                        {
                            "valueId": 64,
                            "attributeValue": "BayTrai"
                        },
                        {
                            "valueId": 63,
                            "attributeValue": "x5-Z8350"
                        },
                        {
                            "valueId": 62,
                            "attributeValue": "m7-6Y75"
                        },
                        {
                            "valueId": 61,
                            "attributeValue": "m5-6Y54"
                        },
                        {
                            "valueId": 60,
                            "attributeValue": "m3-6Y30"
                        },
                        {
                            "valueId": 59,
                            "attributeValue": "Intel酷睿双核i5-4200H"
                        },
                        {
                            "valueId": 58,
                            "attributeValue": "i7-4720"
                        },
                        {
                            "valueId": 57,
                            "attributeValue": "i7-6700"
                        },
                        {
                            "valueId": 56,
                            "attributeValue": "i7-6500"
                        },
                        {
                            "valueId": 55,
                            "attributeValue": "i7-5500"
                        },
                        {
                            "valueId": 54,
                            "attributeValue": "i5-6400"
                        },
                        {
                            "valueId": 53,
                            "attributeValue": "i5-6300"
                        },
                        {
                            "valueId": 52,
                            "attributeValue": "i5-6200"
                        },
                        {
                            "valueId": 51,
                            "attributeValue": "i5-4210"
                        },
                        {
                            "valueId": 50,
                            "attributeValue": "i3-6100"
                        },
                        {
                            "valueId": 49,
                            "attributeValue": "i3-4005"
                        },
                        {
                            "valueId": 48,
                            "attributeValue": "i3-5010"
                        }
                    ],
                    "attributeName": "处理器"
                },
                {
                    "attributeId": 1,
                    "attributeValueList": [
                        {
                            "valueId": 1,
                            "attributeValue": "Windows 10 Home"
                        }
                    ],
                    "attributeName": "操作系统"
                },
                {
                    "attributeId": 113,
                    "attributeValueList": [
                        {
                            "valueId": 650,
                            "attributeValue": "2"
                        },
                        {
                            "valueId": 649,
                            "attributeValue": "1"
                        },
                        {
                            "valueId": 648,
                            "attributeValue": "b"
                        }
                    ],
                    "attributeName": "zh属性22"
                },
                {
                    "attributeId": 111,
                    "attributeValueList": [
                        {
                            "valueId": 641,
                            "attributeValue": "2"
                        },
                        {
                            "valueId": 640,
                            "attributeValue": "1"
                        }
                    ],
                    "attributeName": "zh属性"
                },
                {
                    "attributeId": 109,
                    "attributeValueList": [
                        {
                            "valueId": 630,
                            "attributeValue": "wmw属性SKU5"
                        },
                        {
                            "valueId": 629,
                            "attributeValue": "wmw属性SKU2"
                        },
                        {
                            "valueId": 628,
                            "attributeValue": "wmw属性SKU1"
                        },
                        {
                            "valueId": 627,
                            "attributeValue": "wmw属性SKU3"
                        }
                    ],
                    "attributeName": "wmw属性3"
                },
                {
                    "attributeId": 108,
                    "attributeValueList": [
                        {
                            "valueId": 634,
                            "attributeValue": "wmwSPU3"
                        },
                        {
                            "valueId": 633,
                            "attributeValue": "wmwSPU2"
                        },
                        {
                            "valueId": 632,
                            "attributeValue": "wmwSPU1"
                        },
                        {
                            "valueId": 631,
                            "attributeValue": "wmw属性值1"
                        }
                    ],
                    "attributeName": "wmw属性1"
                },
                {
                    "attributeId": 4,
                    "attributeValueList": [
                        {
                            "valueId": 76,
                            "attributeValue": "64GB"
                        },
                        {
                            "valueId": 75,
                            "attributeValue": "32GB"
                        },
                        {
                            "valueId": 74,
                            "attributeValue": "24GB"
                        },
                        {
                            "valueId": 73,
                            "attributeValue": "16GB"
                        },
                        {
                            "valueId": 72,
                            "attributeValue": "12GB"
                        },
                        {
                            "valueId": 71,
                            "attributeValue": "8GB"
                        },
                        {
                            "valueId": 70,
                            "attributeValue": "6GB"
                        },
                        {
                            "valueId": 69,
                            "attributeValue": "4GB"
                        },
                        {
                            "valueId": 68,
                            "attributeValue": "2GB"
                        }
                    ],
                    "attributeName": "选择内存"
                }
            ],
            "categoryList": null,
            "brandList": [
                {
                    "image": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/4Qo3DMrjVRwqXXoU6Kw.jpg?bindId=147",
                    "brandName": "zh牌",
                    "brandId": 126562
                },
                {
                    "image": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/EYUliswE6xvYCB77x7Q.png?bindId=43",
                    "brandName": "ROG",
                    "brandId": 126559
                },
                {
                    "image": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/h08psqXSw34XWpLE4qD.jpg?bindId=32",
                    "brandName": "测试品牌",
                    "brandId": 126561
                },
                {
                    "image": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/pHRICRLluBbfFF5b8cX.png?bindId=19",
                    "brandName": "21231hh",
                    "brandId": 126558
                },
                {
                    "image": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/vVSJiQSmZFBuEz7LtrU.png?bindId=71",
                    "brandName": "wmwtest",
                    "brandId": 126560
                }
            ]
        },
        "msg": "成功",
        "state": 200,
        "timestamp": 1740107470806
    }
  }
    //返回值
    return {
      goodsData,
      attributeList,
	  seledInfos,
	  attrItemFoucse,	
	  selItemFoucse,
	  onAttrValeTap,
	  onPriceValeTap,
	  onSelItemTap,
	  selType,
	  priceList,
	  sortInfo,
	  onZhSortTap,	  
	  onPriceSortTap,
	  onNewPSortTap,
	  onFreeSortTap,
	  onOnlyStoreSortTap,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      goToByPush,
      L,
      isEmpty,
      keyword,
      firstLoading,
      skeletonData,
      collectGoods,
      loginModalVisibleFlag,
      closeLoingModal,
      
      toGoodsDetail,
			onDuibiTap,
			onSevTap,
			toTopTap,
			goTop,
			showSideMenu,
			sideStyle
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/goodsList.scss";
@import "../../style/base.scss";

.empty_page {
  flex-direction: column;
  padding: 100px;
}

.sld_pagination {
  margin-top: 50px;
  margin-bottom: 95px;
}

/*添加css样式*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style lang="scss">
.side_menu {
    position: fixed;
    top: calc(100vh - 676px);
    right: 30px;
    z-index: 999;

  }
</style>
